// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NameBlock__container-d4f699 {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.NameBlock__sub-title-edcfb7 {
  color: var(--base-110);
  font: var(--font-title-6);
  letter-spacing: var(--font-spacing-title-6);
  margin-bottom: 24px;
}

.NameBlock__form-ef219e {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}

.NameBlock__footer-d9c06b {
  display: flex;
  flex: 0;
  justify-content: flex-end;
}

.NameBlock__username-e7709a {
  margin-bottom: 8px;
}

.NameBlock__input-content-ad8c99 {
  background-color: var(--addition-175);
}`, "",{"version":3,"sources":["webpack://./src/unauthorized/CallInvitation/NameBlock/NameBlock.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AACF;;AAEA;EACE,sBAAA;EACA,yBAAA;EACA,2CAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,OAAA;EACA,yBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,qCAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.sub-title {\n  color: var(--base-110);\n  font: var(--font-title-6);\n  letter-spacing: var(--font-spacing-title-6);\n  margin-bottom: 24px;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.footer {\n  display: flex;\n  flex: 0;\n  justify-content: flex-end;\n}\n\n.username {\n  margin-bottom: 8px;\n}\n\n.input-content {\n  background-color: var(--addition-175);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NameBlock__container-d4f699`,
	"sub-title": `NameBlock__sub-title-edcfb7`,
	"subTitle": `NameBlock__sub-title-edcfb7`,
	"form": `NameBlock__form-ef219e`,
	"footer": `NameBlock__footer-d9c06b`,
	"username": `NameBlock__username-e7709a`,
	"input-content": `NameBlock__input-content-ad8c99`,
	"inputContent": `NameBlock__input-content-ad8c99`
};
module.exports = ___CSS_LOADER_EXPORT___;
